module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.examination) ? _c('div', [_c('a', {
    staticClass: "return-link",
    on: {
      "click": _vm.goToExaminationsList
    }
  }, [_c('img', {
    staticClass: "arrow-img reverse",
    attrs: {
      "src": require("../../../assets/images/arrow-red.png")
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t('GO_BACK_TO_EXAMINATIONS')) + "\n    ")]), _vm._v(" "), (_vm.examination.publishedResultDescription) ? _c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "examination__description col-xs-12"
  }, [_c('h3', {
    staticClass: "title-content"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('EXAMINATION_SUMMARY_FROM', {
    date: _vm.dateFormat(_vm.$moment(_vm.examination.isoDate))
  })) + "\n            ")]), _vm._v(" "), (_vm.examination.additionalData) ? _c('h3', [_vm._v("\n                " + _vm._s(_vm.$t('EXAMINATION_ID', {
    id: _vm.examination.additionalData
  })) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.examination.publishedResultDescription)
    }
  })])]) : _c('div', [_c('div', {
    staticClass: "row examination__description col-xs-12"
  }, [_c('h3', {
    staticClass: "title-content"
  }, [_vm._v("\n                " + _vm._s(((_vm.$t('EXAMINATION_RESULT_FROM')) + " " + (_vm.dateFormat(_vm.$moment(_vm.examination.isoDate))))) + "\n            ")])]), _vm._v(" "), _c('h3', {
    staticClass: "mt-2 mb-4"
  }, [_vm._v(_vm._s(_vm.$t('RESULT_AVAILABLE_AS_FILE')))])]), _vm._v(" "), (_vm.showThermogramAndExportSection) ? _c('div', {
    staticClass: "row my-3"
  }, [_c('div', {
    staticClass: "pull-right mr-3 my-1"
  }, [_c('button', {
    staticClass: "app-btn app-btn--big app-btn-primary",
    on: {
      "click": function($event) {
        return _vm.seeTermogram(_vm.examinationId)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('SEE_TERMOGRAM')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right mr-3 my-1"
  }, [_c('button', {
    staticClass: "app-btn app-btn--big app-btn-primary",
    on: {
      "click": function($event) {
        return _vm.fileExport('pdf')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('PDF_EXPORT')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right mr-3 my-1"
  }, [_c('button', {
    staticClass: "app-btn app-btn--big app-btn-primary",
    on: {
      "click": function($event) {
        return _vm.fileExport('zip')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('DICOM_EXPORT')) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (_vm.examination.documentPreviews.length > 0) ? _c('div', [_c('h3', {
    staticClass: "title-content"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('FILES')) + "\n        ")]), _vm._v(" "), _vm._l((_vm.examination.documentPreviews), function(document) {
    return _c('div', {
      staticClass: "col-xs-12 px-0 file"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(_vm.getDocumentTitle(document))
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "pull-right",
      on: {
        "click": function($event) {
          return _vm.saveDocument(document)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('DOWNLOAD_PDF'))), _c('img', {
      staticClass: "arrow-img",
      attrs: {
        "src": require("../../../assets/images/arrow-red.png")
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "icon",
      on: {
        "click": function($event) {
          return _vm.saveDocument(document)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../../assets/images/pdf-icon.png")
      }
    })])])
  })], 2) : _c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('NO_DOCUMENTS_TO_DOWNLOAD')) + "\n    ")])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-654faf60","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/medical-results/result-detailed.vue
// module id = 1214
// module chunks = 0